import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { router } from './plugins/vue-router';
import './plugins/axios'
import './plugins/vuex'
import './plugins/lodash'
import './plugins/vue-seamless-scroll'
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import '@/assets/css/common.css'
Vue.config.productionTip = false
window.Swiper = Swiper
// 引入echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts;

const date=new Date();
const CURRENTYEAR= date.getFullYear()
Vue.prototype.CURRENTYEAR = CURRENTYEAR
//路由导航守卫
// router.beforeEach((to, from, next) => {
//   //to 要去的路由配置
//   //from 当前的路由配置
//   //next 一定要调用，让to的路由配置继续生效，比如如果去登陆直接next(),否则判断token是否存在，如果存在就next()
//   if (to.path === '/login') return next() ;//使用return，不需要写else
//   //判断其他页面是否有token
//   const token = localStorage.getItem('auth_token');
//   //存在继续往后走
//   if (token) return next();
//   // this.$router.push({name:'login'}) #没有this,无法使用
//   // Message.warning('未登录，请先登录！')
//   router.push({
//     name: 'login'
//   })
// })
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
